import { composeDecorators } from 'draft-js-plugins-editor';

import createDecorator from './createDecorator';

export default (config = {}) => {
    const editorProps = {
        getEditorRef: null,
        isReadOnly: true
    };

    const decorator = config.decorator
        ? composeDecorators(config.decorator, createDecorator({ config, editorProps }))
        : createDecorator({ config, editorProps });

    return {
        initialize: ({ getEditorRef, getReadOnly }) => {
            editorProps.getEditorRef = getEditorRef;
            editorProps.isReadOnly = getReadOnly();
        },
        decorator,
        blockRendererFn: (contentBlock, { getEditorState }) => {
            if (contentBlock.getType() === 'atomic') {
                const entityKey = contentBlock.getEntityAt(0);
                const contentState = getEditorState().getCurrentContent();
                const resizeData = entityKey ? contentState.getEntity(entityKey).getData() : {};

                return { props: { resizeData } };
            }

            return null;
        }
    };
};
